import AudioPlayer from "./AudioPlayer/AudioPlayer";
import InfoComponent from "./InfoComponent/InfoComponent";
import ListeningInputQuestions from "./ListeningInputQuestions/ListeningInputQuestions";
import MultipleChoice from "./MultipleChoice/MultipleChoice";
import { PdfComponent } from "./PdfComponent/PdfComponent";
import WritingInput from "./WritingInput/WritingInput";
import speakingContentImage from "../../../Assets/speakingSectionContentCard.png";
import SpeakingSection from "./Speaking_v2";
import { useContext } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";

const ContentInterfaceElement = ({
  content,
  componentIndex,
  sectionData,
  handleMultipleChoiceSelection,
  userAnswers,
  displayPdfHandler,
  updateInputAnswer,
  examGuid,
  selectedAccent,
  detectOverflowAndDisplayPopup,
  updateWritingAnswer,
}) => {
  const { userData, route } = useContext(AppContext);

  switch (content.type) {
    case "multipleChoice":
      return (
        <MultipleChoice
          content={content}
          setSelectedAnswerIndex={(answerId) =>
            handleMultipleChoiceSelection(content.questionId, answerId)
          }
          questionNumber={userAnswers[content.questionId].questionNumber}
          selectedAnswer={userAnswers[content.questionId].answerId}
          componentIndex={componentIndex}
          pdf={content.pdf}
          openPDF={displayPdfHandler}
        />
      );
    case "textArea":
      return (
        <WritingInput question={content.question} extract={content.extract} />
      );
    case "input":
      return (
        <ListeningInputQuestions
          updateInputAnswer={updateInputAnswer}
          componentIndex={componentIndex}
          content={content}
          userAnswers={userAnswers}
          openPDF={displayPdfHandler}
        />
      );
    case "info":
      return (
        <InfoComponent content={content} componentIndex={componentIndex} />
      );
    case "audio":
      return (
        <AudioPlayer
          audioSegments={content.audioSegments}
          showPauseButton={content.showPauseButton}
          createURL={false}
          userData={userData}
          content={content}
          route={route}
          key={`Audio Player - ${componentIndex} - ${sectionData.sectionId}`}
          selectedAccent={selectedAccent}
        />
      );
    case "speaking":
      return (
        <SpeakingSection
          examGuid={examGuid}
          ExamAttemptId={sectionData.ExamAttemptId}
        />
      );
    case "image":
      return (
        <img
          className="imageComponent"
          onLoad={detectOverflowAndDisplayPopup}
          src={speakingContentImage}
          alt={content.alt}
        />
      );
    case "writing":
      return (
        <WritingInput
          answer={userAnswers[content.questionId].answer}
          setAnswer={(value) => updateWritingAnswer(content.questionId, value)}
        />
      );
    case "pdf":
      return <PdfComponent openPDF={displayPdfHandler} content={content} />;
    default:
      return (
        <div>
          <p>Unknown content type</p>
        </div>
      );
  }
};

export default ContentInterfaceElement;
